import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import en from '../../locales/en/translation.json';
import kh from '../../locales/kh/translation.json';
import mm from '../../locales/mm/translation.json';
import th from '../../locales/th/translation.json';
import zhHans from '../../locales/zh-Hans/translation.json';
import zhHant from '../../locales/zh-Hant/translation.json';
import { DefaultLocale, Locales } from '../../types/locale.types';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    th: { translation: th },
    kh: { translation: kh },
    mm: { translation: mm },
    'zh-Hans': { translation: zhHans },
    'zh-Hant': { translation: zhHant },
  },
  lng: DefaultLocale,
  fallbackLng: DefaultLocale,
  supportedLngs: Locales,
  nonExplicitSupportedLngs: false,
  debug: false,
  interpolation: {
    escapeValue: false,
    prefix: '{',
    suffix: '}',
    skipOnVariables: false,
  },
  detection: {
    order: [],
  },
  load: 'currentOnly',
});

export default i18n;
